import { StatisticsConst } from '@/store/constant/statistics.constant'
import type { IStatistics } from '@/store/models/statistics.model'
import { StatisticsUnionType } from '@/store/actions/statistics.action'

const intialState: IStatistics = {
    datasetTotalCount: 0,
    openSourceDatasetTotalCount: 0,
    fileTotalCount: 0,
    fileTotalSize: 0,
    dataType: {
        Video: 0,
        Text: 0,
        GPS: 0,
        Audio: 0,
        Image: 0,
        Other: 0,
    },
    taskType: {
        'Action/Event Detection': 0,
        ASR: 0,
        Others: 0,
        'Acoustic Scene Classification': 0,
        'Gaze Estimation': 0,
        'Depth Estimation': 0,
    },
    useContext: {
        Vehicle: 0,
        Others: 0,
        'Autonomous Driving': 0,
        Animal: 0,
        Aesthetics: 0,
        Agriculture: 0,
        'AR/MR': 0,
    },
    dataLabels: {
        KeyPoints2D: 0,
        Others: 0,
        'Box2D Tracking': 0,
        PolyLine2D: 0,
        Box3D: 0,
        Box2D: 0,
        Audio: 0,
        'Box3D Tracking': 0,
        Polygon2D: 0,
    }
}

export default function statisticsReducer(
    state = intialState,
    action: StatisticsUnionType
): any {
    switch (action.type) {
        case StatisticsConst.SET_STATISTICS:
            return {
                ...state,
                statistics: action.payload.data
            }
        default:
            return state
    }
}
